// Phase 6.D-9 — 레시피 layout. SubNav (원가계산·메뉴) + Outlet.
//
// 사용자 결정 (2026-04-26 6.D-9, 사용자 신고 1번):
//   "메뉴추가/레시피추가 sub 가 중복. 둘이 합쳐서 하나의 메뉴로 가는게 맞다."
//
// sub-route 2:
//   1. 원가계산 → /settings/recipes/cost
//   2. 메뉴     → /settings/recipes/menus    (default, 메뉴+레시피 통합 행 편집)
//
// /settings/recipes index → /settings/recipes/menus 로 redirect (App.tsx).
// /settings/recipes/add  legacy 진입은 /menus 로 redirect (App.tsx 추가).
//
// SettingsLayout 이 PageHeader 를 이미 렌더하므로, 여기엔 SubNav + Outlet 만.

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SubNav, type SubNavItem } from '../../../components/primitives';

const SUB_ITEMS: SubNavItem[] = [
  { id: 'cost', label: '원가계산' },
  { id: 'menus', label: '메뉴' },
];

const PATH_BY_ID: Record<string, string> = {
  cost: '/settings/recipes/cost',
  menus: '/settings/recipes/menus',
};

function activeFromPath(pathname: string): string {
  if (pathname.startsWith('/settings/recipes/cost')) return 'cost';
  return 'menus';
}

export function SettingsRecipesLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const active = activeFromPath(location.pathname);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <SubNav
        items={SUB_ITEMS}
        active={active}
        onChange={(id) => {
          const to = PATH_BY_ID[id];
          if (to) navigate(to);
        }}
        style={{ alignSelf: 'flex-start' }}
      />
      <Outlet />
    </div>
  );
}
